import { StylesConfig } from 'react-select'

function prefixedText(color: string, prefix = '"Group by:"', customMarginRight = 23, customWidth = 53) {
    return {
        alignItems: 'center',
        display: 'flex',
        cursor: "pointer",
        ':before': {
            color: color,
            borderRadius: 10,
            content: prefix,
            display: 'block',
            marginRight: customMarginRight,
            width: customWidth,
            fontWeight: 600,
        },
    }
}

export function groupByPrefixedStyle(styleColourSecondary: string, styleColourAlternative: string): StylesConfig<any> {
    return {
        placeholder: (styles) => ({ ...styles, ...prefixedText(styleColourSecondary, '"Group by:"'), cursor: "pointer" }),
        singleValue: (styles, { data }) => ({ ...styles, ...prefixedText(styleColourSecondary, '"Group by:"'), cursor: "pointer" }),
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            return {
                ...styles,
                cursor: !isSelected ? "pointer" : "default",
                backgroundColor: isSelected
                    ? styleColourAlternative
                    : isFocused
                        ? styleColourSecondary
                        : `#fff`,
                color: isSelected
                    ? `#fff`
                    : isFocused
                        ? `#fff`
                        : `#000`,
            };
        },
        control: (styles) => ({
            ...styles,
            cursor: 'pointer',
        }),
    };
};

export function rolePrefixedStyle(styleColourSecondary: string, styleColourAlternative: string): StylesConfig<any> {
    return {
        placeholder: (styles) => ({ ...styles, ...prefixedText(styleColourSecondary, '"Role:"', 23, 17), cursor: "pointer" }),
        singleValue: (styles, { data }) => ({ ...styles, ...prefixedText(styleColourSecondary, '"Role:"', 23, 17), cursor: "pointer" }),
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            return {
                ...styles,
                cursor: !isSelected ? "pointer" : "default",
                backgroundColor: isSelected
                    ? styleColourAlternative
                    : isFocused
                        ? styleColourSecondary
                        : `#fff`,
                color: isSelected
                    ? `#fff`
                    : isFocused
                        ? `#fff`
                        : `#000`,
            };
        },
        control: (styles) => ({
            ...styles,
            cursor: 'pointer',
        }),
    }
};

export function departmentPrefixedStyle(styleColourSecondary: string, styleColourAlternative: string): StylesConfig<any> {
    return {
        placeholder: (styles) => ({ ...styles, ...prefixedText(styleColourSecondary, '"Department:"', 23, 75), cursor: "pointer" }),
        singleValue: (styles, { data }) => ({ ...styles, ...prefixedText(styleColourSecondary, '"Department:"', 23, 75), cursor: "pointer" }),
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            return {
                ...styles,
                cursor: !isSelected ? "pointer" : "default",
                backgroundColor: isSelected
                    ? styleColourAlternative
                    : isFocused
                        ? styleColourSecondary
                        : `#fff`,
                color: isSelected
                    ? `#fff`
                    : isFocused
                        ? `#fff`
                        : `#000`,
            };
        },
        control: (styles) => ({
            ...styles,
            cursor: 'pointer',
        }),
    }
};

export function locationPrefixedStyle(styleColourSecondary: string, styleColourAlternative: string): StylesConfig<any> {
    return {
        placeholder: (styles) => ({ ...styles, ...prefixedText(styleColourSecondary, '"Location:"', 23, 48), cursor: "pointer" }),
        singleValue: (styles, { data }) => ({ ...styles, ...prefixedText(styleColourSecondary, '"Location:"', 23, 48), cursor: "pointer" }),
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            return {
                ...styles,
                cursor: !isSelected ? "pointer" : "default",
                backgroundColor: isSelected
                    ? styleColourAlternative
                    : isFocused
                        ? styleColourSecondary
                        : `#fff`,
                color: isSelected
                    ? `#fff`
                    : isFocused
                        ? `#fff`
                        : `#000`,
            };
        },
        control: (styles) => ({
            ...styles,
            cursor: 'pointer',
        }),
    }
};